export default "__VITE_ASSET__D0nhpoX$__"